const types = {
  BASIC: 'basic',
  MAINTAIN: 'maintain',
  PER_HOUR: 'per_hour',
  WINDOWS: 'windows',
  SPRING_CLEANING: 'spring_cleaning',
  AFTER_REPAIR: 'after_repair',
  AFTER_THE_FIRE: 'after_the_fire',
  SEWERAGE: 'sewerage',
};

const statuses = {
  SELECTS: 'selects',
  WAITING_PHOTO: 'waiting_photo',
  LONG: 'long',
};

const generalStatuses = {
  OPEN: 'open',
  CLOSE: 'close',
  SELECTED_OTHER: 'selected_other',
};

export {
  types,
  statuses,
  generalStatuses,
};
